import {createTheme} from '@material-ui/core/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#820263',
        },
        secondary: {
            main: '#45547b',
        },
        disabledColor: '#acaaaa',
        white: '#ffffff',
    },
    maxContentWidth: '1000px',
    bigButtonSize: '200px',
    typography: {
        h1: {
            fontSize: 24
        },
        h2: {
            fontSize: 18
        },
        h3: {
            fontSize: 18
        },
        subtitle1: {
            fontWeight: 'bold'
        }
    }
});